import { getClient } from '@/lib/restClient';
import { IntegrationReadyDeliveryStoreService } from '@/services/StoreManagement/IntegrationReadyDeliveryStore/IntegrationReadyDeliveryStoreService';

export type CreateIntegrationReadyDeliveryStoreParams = {
  external_store_id: string;
  delivery_service_id: number;
  external_store_name: string;
  is_order_manager?: boolean | null;
};

export const useCreateIntegrationReadyDeliveryStore = async (
  params: CreateIntegrationReadyDeliveryStoreParams[]
): Promise<void> => {
  const integrationReadyDeliveryStoreService =
    new IntegrationReadyDeliveryStoreService(getClient());
  return await integrationReadyDeliveryStoreService.create(params);
};
